import { toast } from "react-toastify";

import { setList } from "../../redux/businessSidebarTitlesSlice";
import { setData, setId, setSummary, setType } from "../../redux/bussinessSlice";
import { api, paymentApi } from "../../utils/axios/Config";
import {
  convertPersianToEnglishNumber,
  convertTrackingCodesToString,
  handleErrorApi,
} from "../../utils/utils";
import { bussinessNavbarItems, posBussinessNavbarItems } from "../constants";

export async function sendEmail(email = "") {
  try {
    const session = await api.post(`/users/otp/send/`, {
      email: email,
      receiver_type: "email",
    });
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function verifyEmail({ email, otp }) {
  try {
    const session = await api.post(`/users/otp/email/verify/`, {
      otp_key: email,
      otp: otp,
    });
    ////console.log(session);
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getUserTicketData() {
  try {
    const session = await api.get(`/users/ticket/`);
    ////console.log(session, "getUserStatus");
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getUserBusinessList({ currentPage = 1, pageSize = 20 }) {
  try {
    const session = await api.get(
      `/businesses/user/list/?order_by=id&descending=true&limit=${pageSize}&offset=${
        (currentPage - 1) * pageSize
      }`,
    );

    return session?.data;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getSidebarBusinessList({ currentPage = 1, pageSize = 100 }) {
  //console.log(currentPage, pageSize,"currentPage, pageSize")
  try {
    const session = await api.get(
      // `/businesses/user/list/?order_by=id&descending=true&limit=${pageSize}&offset=${
      `/businesses/user/list/?order_by=id&&descending=true&limit=${pageSize}&offset=${
        (currentPage - 1) * pageSize
      }`,
    );
    return session?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      return { count: 0, items: [] };
    }
    handleErrorApi(error);
  }
}
export async function getPortData(id) {
  try {
    const session = await api.get(`/forms/${id}/`);
    ////console.log(session, "getUserStatus");
    return session?.data;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getFormDataByLink(linkId) {
  try {
    const session = await api.get(`/forms/link/${linkId}/`);
    ////console.log(session, "getUserStatus");
    return session?.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function createBussiness({ data, type }) {
  try {
    const session = await api.post(`/businesses/${type}/ticket/`, data);
    return session;
  } catch (error) {
    //console.log(error);
    handleErrorApi(error);
  }
}
export async function createForm(data) {
  try {
    const session = await api.post(`/forms/`, data);

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function submitPurchaseForm(data) {
  try {
    const session = await paymentApi.post(`/transactions/v2/purchase/`, data);

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getUserApprovedAccounts() {
  try {
    const session = await api.get("/accounts/?active_status=true&ban_status=false");
    if (session.data.count) {
      return true;
    }

    return false;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getTicketsCategoryList() {
  try {
    const session = await api.get("/tickets/category/");
    if (!session) alert("لیست مقادیر کتگوری تیکت ها گرفته نشد.");

    return session.data.items;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getTicketsPriorityList() {
  try {
    const session = await api.get("/tickets/priority/");
    ////console.log(session);
    if (!session) alert("لیست مقادیر اولویت تیکت ها گرفته نشد.");

    return session.data.items;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getAvailableBalance({ wallet_id }) {
  try {
    const session = await api.get(`/wallets/balance/${wallet_id}/`);
    ////console.log(session);
    if (!session) alert("لیست مقادیر اولویت تیکت ها گرفته نشد.");

    return session?.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function submitTicket(body) {
  try {
    const response = await api.post(`/tickets/`, body);
    return response;
  } catch (error) {
    let errorMessage = "خطایی رخ داد";
    ////console.log(error, "submitTicket");

    if (error.response) {
      const status = error.response.status;

      // Customize the error message based on the status code
      if (status.toString().startsWith(50)) {
        errorMessage = "خطای داخلی سرور";
      } else if (status === 400) {
        errorMessage = error.response.data.detail.message || "درخواست نامعتبر است";
      } else if (status === 404) {
        errorMessage = "صفحه یافت نشد";
      } else {
        errorMessage = error.response.data.detail.message || "خطایی رخ داد";
      }

      toast.error(`${errorMessage}`, "خطا !", 2000);
    } else {
      toast.error("خطا در ارتباط با سرور", "خطا !", 2000);
    }
  }
}

export async function submitGateway(body) {
  try {
    const response = await api.post(`/gateways/`, body);
    return response;
  } catch (error) {
    //console.log(error, "eror");
    handleErrorApi(error);
  }
}

const fetchBusinessData = async (type, id) => {
  return await api.get(`/businesses/${type}/${id}/`);
};

// Fetch business income summary
const fetchBusinessIncomeSummary = async (type, id) => {
  ////console.log(businessId);
  return await api.post(`/businesses/${type}/${id}/income/summary/`, {
    start_timestamp: monthTimeStamp(),
  });
};

// Main function to get business data and income summary
export async function getBussinessData({ type, id, dispatch }) {
  dispatch(setType(type));
  dispatch(setId(id));

  try {
    const businessResponse = await fetchBusinessData(type, id);
    const has_pos = businessResponse?.data?.business?.pose_specific;

    if (businessResponse) dispatch(setData(businessResponse.data));

    if (has_pos) {
      dispatch(setList(posBussinessNavbarItems));
    } else {
      dispatch(setList(bussinessNavbarItems));
    }
  } catch (error) {
    handleError(error);
  }

  try {
    const incomeSummaryResponse = await fetchBusinessIncomeSummary(type, id);
    ////console.log(incomeSummaryResponse, "incomeSummaryResponse");
    if (incomeSummaryResponse) dispatch(setSummary(incomeSummaryResponse.data));
  } catch (error) {
    handleError(error);
  }

  return { response: "ok" };
}

const handleError = (error) => {
  let errorMessage = "خطایی رخ داد";

  if (error.response) {
    const status = error.response.status;

    // Customize the error message based on the status code
    if (status.toString().startsWith(50)) {
      errorMessage = "خطای داخلی سرور";
    } else if (status === 400) {
      errorMessage = error.response.data.detail.message || "درخواست نامعتبر است";
    } else if (status === 404) {
      errorMessage = "صفحه یافت نشد";
    } else {
      errorMessage = error.response.data.detail.message || "خطایی رخ داد";
    }
  } else {
    errorMessage = "خطا در ارتباط با سرور";
  }

  NotificationManager.error(`${errorMessage}`, "خطا !", 2000);
};

const monthTimeStamp = () => {
  var todayDate = new Date();
  var month = todayDate.getMonth();
  todayDate.setMonth(todayDate.getMonth() - 1);
  if (todayDate.getMonth() === month) todayDate.setDate(0);
  todayDate.setHours(0, 0, 0, 0);
  let startTime = (todayDate / 1000) | 0;
  ////console.log(startTime);
  return startTime;
};

export async function getTransactionList({
  type,
  businessId,
  searchTerm,
  currentPage,
  pageSize,
  transactionType,
}) {
  //console.log(searchTerm, "debouncedQueryParams");
  const debounce = {
    ...searchTerm,
    ...[
      "from_amount",
      "to_amount",
      "exact_amount",
      "reference_number",
      "card_number",
      "track_id",
      "vanda_tracking_code",
    ].reduce((acc, key) => {
      if (searchTerm?.[key]) {
        acc[key] = convertPersianToEnglishNumber(searchTerm[key]);
      } else {
        acc[key] = "";
      }
      return acc;
    }, {}),
    form_id: searchTerm?.form_id && typeof searchTerm.form_id === "object" ? searchTerm.form_id.id : "",
    gateway_id:
      searchTerm?.gateway_id && typeof searchTerm.gateway_id === "object" ? searchTerm.gateway_id.id : "",
  };
  const filteredParams = Object.fromEntries(
    Object.entries(debounce).filter(([key, value]) => value !== "" && value !== undefined),
  );
  const queryParam = new URLSearchParams(filteredParams);
  try {
    const queryParams = [
      `business_type=${type}`,
      businessId ? `business_id=${businessId}` : "",
      queryParam,
      `limit=${pageSize}`,
      `offset=${(currentPage - 1) * pageSize}`,
    ];

    if (transactionType) {
      queryParams.unshift(`transaction_type=${transactionType}`);
    }

    const queryString = queryParams.filter(Boolean).join("&");

    const session = await paymentApi.get(`/transactions/?${queryString}`, {
      responseType: "text",
    });

    const result = convertTrackingCodesToString(session);

    //  console.log({session})
    return result;
  } catch (error) {
    //console.log(error, "transactionList");
  }
}

export async function updateGatewayPin(gateway_id) {
  try {
    const response = await api.patch(`/gateways/update/pin/${gateway_id}/`);
    return response;
  } catch (error) {
    let errorMessage = "خطایی رخ داد";
    ////console.log(error, "submitTicket");

    if (error.response) {
      const status = error.response.status;

      // Customize the error message based on the status code
      if (status.toString().startsWith(50)) {
        errorMessage = "خطای داخلی سرور";
      } else if (status === 400) {
        errorMessage = error.response.data.detail.message || "درخواست نامعتبر است";
      } else if (status === 404) {
        errorMessage = "صفحه یافت نشد";
      } else {
        errorMessage = error.response.data.detail.message || "خطایی رخ داد";
      }

      NotificationManager.error(`${errorMessage}`, "خطا !", 2000);
    } else {
      NotificationManager.error("خطا در ارتباط با سرور", "خطا !", 2000);
    }
  }
}

export async function getSettlementsList(searchTerm, currentPage, pageSize) {
  const filteredParams = Object.fromEntries(
    Object.entries(searchTerm).filter(([key, value]) => value !== ""),
  );
  const queryParam = new URLSearchParams(filteredParams);
  try {
    const session = await api.get(
      `/wallets/settlements/?${queryParam}&limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`,
    );
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function excelExport({ data, searchTermRef, url, type, businessId }) {
  //console.log({ data, searchTermRef, url, type, businessId });
  const filteredParams = Object.fromEntries(
    Object.entries(searchTermRef).filter(([key, value]) => value !== ""),
  );
  try {
    const session = await api.post(`/${url}/export/excel/`, {
      fields: data,
      ...filteredParams,
      business_type: type,
      business_id: businessId,
    });

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function updateBussinessProfile(business_type, business_id, file) {
  //console.log(file, "file");
  try {
    const response = await api.patch(`/businesses/${business_type}/update/logo/${business_id}/`, {
      logo: file,
    });

    return response;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getBussinessStatistics({ business_type, business_id, time_frame }) {
  try {
    const response = await paymentApi.get(
      `/reports/transactions/${time_frame}/detail/?business_type=${business_type}&business_id=${business_id}`,
    );
    return response?.data;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getBussinessBalance({ business_type, business_id }) {
  //console.log("getBussinessBalance run");
  try {
    const response = await api.get(
      `/businesses/balance/total/?business_type=${business_type}&business_id=${business_id}`,
    );
    return response?.data;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getIbanDetails(iban = "") {
  if (!iban.startsWith("IR")) {
    iban = `IR${iban}`;
  }
  ////console.log(email, "email");
  try {
    const session = await api.get(`/accounts/inquiry/iban/?iban=${iban}`);

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function getBankCardDetails(card_number = "") {
  ////console.log(email, "email");
  try {
    const session = await api.get(`/accounts/inquiry/card/?card_number=${card_number}`);

    console.log({ session });

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function updateTransactionVerified(id) {
  try {
    const response = await paymentApi.post(`/transactions/update/verify/${id}/`);
    return response;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getPosPosTerminals(searchTerm, currentPage, pageSize) {
  const filteredParams = Object.fromEntries(Object.entries(searchTerm).filter(([key, value]) => value));
  const queryParam = new URLSearchParams(filteredParams);
  //console.log(queryParam, "queryParam");
  try {
    const session = await api.get(
      `/pos/?${queryParam}&limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`,
    );
    //console.log(session, "api update user");
    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getGatewayList({ type, businessId, currentPage, pageSize }) {
  const bussinessQuery = type === "real" ? "real_business_id" : "legal_business_id";

  try {
    const session = await api.get(
      `/gateways/?${bussinessQuery}=${businessId}&limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`,
    );
    return session;
  } catch (error) {
    //console.log(error, "transactionList");
  }
}
export async function getFormList({ type, businessId, currentPage, pageSize }) {
  const bussinessQuery = type === "real" ? "real_business_id" : "legal_business_id";

  try {
    const session = await api.get(
      `/forms/?${bussinessQuery}=${businessId}&limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`,
    );
    return session;
  } catch (error) {
    //console.log(error, "transactionList");
  }
}

export async function getTicketsList({ currentPage, pageSize }) {
  try {
    const session = await api.get(`/tickets/?limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`);
    return session;
  } catch (error) {
    //console.log(error, "getTicketsList");
  }
}

export async function getExports({ currentPage, pageSize }) {
  try {
    const session = await api.get(`/exports/?limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`);
    return session;
  } catch (error) {
    //console.log(error, "getTicketsList");
  }
}

export async function getForm(id) {
  try {
    const session = await api.get(`/forms/${id}/`);

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getMessages({ userId, currentPage, pageSize }) {
  try {
    const session = await api.get(
      `/messages/?user_id=${userId}&limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`,
    );
    return session;
  } catch (error) {
    //console.log(error, "transactionList");
  }
}
export async function getNotifications({ currentPage, pageSize }) {
  try {
    const session = await api.get(`/notifications/?limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`);
    return session;
  } catch (error) {
    //console.log(error, "transactionList");
  }
}

export async function getNotificationSetting(userId) {
  ////console.log(email, "email");
  try {
    const session = await api.get(`/notifications/settings/${userId}/`);

    console.log({ session });

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}
export async function updateNotificationSetting({ userId, updatedData }) {
  ////console.log(email, "email");
  try {
    const session = await api.put(`/notifications/settings/${userId}/`, updatedData);

    console.log({ session });

    return session;
  } catch (error) {
    handleErrorApi(error);
  }
}

export async function getMarketerReferedList({ currentPage, pageSize }) {
  try {
    return await api.get(`/users/me/referred/list/?limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`);
  } catch (error) {
    console.log(error, "getMarketerReferedList");
  }
}

export async function getMarketerSettlements({ currentPage, pageSize, marketer_id }) {
  try {
    return await api.get(
      `/commissions/settlements/?limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`,
    );
  } catch (error) {
    console.log(error, "getMarketerSettlements");
  }
}

export async function generateMarketerSettlement(data) {
  try {
    return await api.post(`/commissions/settlements/`, data);
  } catch (error) {
    console.log(error, "getMarketerSettlements");
  }
}
